const isSummaryTitleValid = summaryTitle => !!(summaryTitle && (summaryTitle.text || summaryTitle.text_icon));

export { isSummaryTitleValid };
